// src/pages/Dashboard.jsx
import React from 'react';
import Sidebar from '../Components/Sidebar';
import '../Style/Dashboard.css';
import {
  FaUsers,
  FaBriefcase,
  FaPlay,
  FaCheckCircle,
  FaTimesCircle,
  FaTrash,
} from 'react-icons/fa';

export default function Dashboard() {
  const stats = [
    { id: 1, label: 'Users',          value: 128, icon: <FaUsers /> },
    { id: 2, label: 'Jobs',           value: 256, icon: <FaBriefcase /> },
    { id: 3, label: 'Active Jobs',    value: 64,  icon: <FaPlay /> },
    { id: 4, label: 'Complete Jobs',  value: 160, icon: <FaCheckCircle /> },
    { id: 5, label: 'Declined Jobs',  value: 32,  icon: <FaTimesCircle /> },
    { id: 6, label: 'Deleted Jobs',   value: 8,   icon: <FaTrash /> },
  ];

  return (
    <div className="dashboard-page">
      <Sidebar />
      <main className="dashboard-main">
        <h2 className="dashboard-title">Dashboard</h2>
        <div className="cards-grid">
          {stats.map((stat) => (
            <div key={stat.id} className="stat-card">
              <div className="icon-wrapper">{stat.icon}</div>
              <div className="stat-info">
                <h3 className="stat-value">{stat.value}</h3>
                <p className="stat-label">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
